import { Flex, Icon, useColorModeValue } from "@chakra-ui/react";

// Types
import { Props } from "./Alert.type";

// Contants
import { alertTypeColorMapping, alertTypeIconMapping } from "./constants";

const Alert = ({ type, withIcon = true, children, ...rest }: Props) => {
  const bgColor = useColorModeValue(alertTypeColorMapping[type].bg, "#202325");

  return (
    <Flex
      mt="0.5rem"
      p="0.5rem"
      borderRadius="8px"
      alignItems="center"
      gap="8px"
      bg={bgColor}
      color={alertTypeColorMapping[type].color}
      {...rest}
    >
      {withIcon && <Icon as={alertTypeIconMapping[type]} />}
      {children}
    </Flex>
  );
};

export default Alert;
